class Role {
  id = null;
  title = "";
  active = true;
}

export default Role;
